import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setCurrentWorkspaceUsersIds } from '../slices/currentWorkspace';
import { setUsers } from '../slices/users';
import { getBrandsByWorkspace } from './brands';
import { getCustomersByWorkspace } from './customers';
import { getDevicesByWorkspace } from './devices';
import { getEmergencyContactListByWorkspaceId } from './emergencyContactLists';
import { getEmergencyContactByWorkspaceId } from './emergencyContacts';
import { getEventGroupByWorkspaceId } from './eventGroups';
import { getEventsByWorkspace } from './events';
import { getInvitationsByWorkspace } from './invitations';
import { getModelsByWorkspace } from './models';
import { getResolutionsByWorkspace } from './resolutions';

export const getUsersByWorkspace = createAsyncThunk(
  'users/getUsersByWorkspace',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      try {
        const { data } = await api.workspace.getUsersByWorkspace({
          workspaceId,
        });
        if (data.getUsersByWorkspaceId.users) {
          dispatch(setUsers(data.getUsersByWorkspaceId.users));
          dispatch(
            setCurrentWorkspaceUsersIds(
              data.getUsersByWorkspaceId.users.map((user) => user.id)
            )
          );
        }
        setLoading(false);
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
      }
    } else {
      setErrors('generalError');
      setLoading(false);
    }
  }
);

export const fillCurrentWorkspace = createAsyncThunk(
  'workspaces/fillCurrentWorkspace',
  async (workspaceId, { dispatch }) => {
    dispatch(
      getCustomersByWorkspace({
        workspaceId,
      })
    );

    await dispatch(
      getDevicesByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getUsersByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getInvitationsByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getEventGroupByWorkspaceId({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getEventsByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getBrandsByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getModelsByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    await dispatch(
      getResolutionsByWorkspace({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getEmergencyContactByWorkspaceId({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    dispatch(
      getEmergencyContactListByWorkspaceId({
        workspaceId,
        setLoading: () => {},
        setErrors: () => {},
      })
    );

    return null;
  }
);

export const loadDefaultData = createAsyncThunk(
  'init/loadInitialData',
  async (workspaceId, { dispatch }) => {
    await dispatch(getModelsByWorkspace({ workspaceId })).unwrap();
    await dispatch(getBrandsByWorkspace({ workspaceId })).unwrap();
    await dispatch(getEventGroupByWorkspaceId({ workspaceId })).unwrap();
    await dispatch(getResolutionsByWorkspace({ workspaceId })).unwrap();
  }
);
